import { find, get } from "lodash";
import { MdOutlineWarning } from "react-icons/md";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import InfoBox from "../InfoBox";

const View = ({ count, projects, onClick, take }) => {
  return (
    <div className="duplicate-check-wrapper" key="DUPLICATE">
      <InfoBox
        icon={<MdOutlineWarning size={22} />}
        content={
          <div>
            <b>
              {count} doublon(s) potentiel(s) - <smal>{take} affichés</smal>
            </b>
            <p>Cliquez sur un doublon pour voir les détails complets.</p>
          </div>
        }
        variant="warning"
      />
      <div className="duplicate-check-wrapper__list">
        {projects.map((project) => {
          const { contact } = project;
          const email = get(
            find(get(contact, "telecoms", []), {
              system: CONTACT_POINT_SYSTEM.EMAIL,
            }),
            "value",
          );
          const phone = get(
            find(get(contact, "telecoms", []), {
              system: CONTACT_POINT_SYSTEM.PHONE,
            }),
            "value",
          );
          const zipCode = get(
            find(get(contact, "telecoms", []), {
              system: CONTACT_POINT_SYSTEM.ZIP_CODE,
            }),
            "value",
          );

          return (
            <InfoBox
              key={get(contact, "id")}
              content={
                <div onClick={() => onClick(project)}>
                  <h3>
                    {get(contact, "user.firstname")}{" "}
                    {get(contact, "user.lastname")}
                  </h3>
                  {email && <p>Email : {email}</p>}
                  {phone && <p>Téléphone : {phone}</p>}
                  {zipCode && <p>Code postal : {zipCode}</p>}
                </div>
              }
              variant="warning--outline"
            />
          );
        })}
      </div>
    </div>
  );
};

export default View;
